import { useEffect, useState } from "react";
import { cn } from "@repo/utils";
import type { Brand, BrandPath } from "~/types/api";
import { BrandPathsControl } from "../brand-paths-control/brand-paths-control";

export type EditBrandPath = BrandPath & { isNew?: boolean };

type Props = {
  brand: Brand;
  expanded: boolean;
};

export const BrandPaths = ({ brand, expanded }: Props) => {
  const [brandPaths, setBrandPaths] = useState<EditBrandPath[]>(brand.brandPaths || []);

  useEffect(() => {
    setBrandPaths(brand.brandPaths || []);
  }, [brand.brandPaths, brand.id]);

  return (
    <div
      className={cn("grid transition-all duration-300 ease-in-out", {
        "mt-4 grid-rows-[1fr] opacity-100": expanded,
        "grid-rows-[0fr] opacity-0": !expanded,
      })}
    >
      <div
        className={cn({
          "overflow-hidden": !expanded,
          "overflow-visible": expanded,
        })}
      >
        <BrandPathsControl
          mode="edit"
          brandId={brand.id}
          brandPaths={brandPaths}
          addBrandPath={() =>
            setBrandPaths((prev) => [...prev, { path: "", includeSubFolders: false, isNew: true }])
          }
          updateBrandPath={(index, newProps) => {
            setBrandPaths((prev) => prev.map((p, i) => (i === index ? { ...p, ...newProps } : p)));
          }}
          removeBrandPath={(index) => {
            setBrandPaths((prev) => prev.filter((_, i) => i !== index));
          }}
        />
      </div>
    </div>
  );
};
